import Reveal from "@/components/Reveal";

export default function PageHero({ overline, title, description }) {
    return (
        <section className="noise-overlay relative overflow-hidden bg-navy py-20 lg:py-28" data-testid="page-hero">
            <div className="blueprint-grid-dark absolute inset-0" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">{overline}</p>
                    <h1 className="mt-4 max-w-3xl font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
                        {title}
                    </h1>
                    {description && (
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 lg:text-lg">{description}</p>
                    )}
                </Reveal>
            </div>
        </section>
    );
}
